import React from 'react';

const MaintenanceContentEN = () => {
    return (
        <div className="maintenance-container">
            <img src="/assets/images/logos/logo-gsa.png" alt="GSA Logo" className="maintenance-logo" />
            <h1 className="maintenance-title">We Are Improving Our Site</h1>
            <p className="maintenance-message">
                Some features, such as login and registration, may be temporarily disabled.
                We appreciate your understanding and patience as we work to enhance your experience.
            </p>
            <p className="maintenance-contact">
                If you need urgent assistance, please contact us at: <a href="mailto:info@divegsa.com">info@divegsa.com</a>
            </p>
        </div>
    );
};

export default MaintenanceContentEN; 